'use client';

import { useDecisions } from '@libs/common-next';

import { useDismissProfileCelebrationOutsideMyAccount } from './use-dismiss-profile-celebration-outside-my-account';

export function ProfileCelebrationRouteGuard() {
    const isFeatureEnabled = useDecisions('ff_complete_profile');

    useDismissProfileCelebrationOutsideMyAccount({
        enabled: isFeatureEnabled,
    });
    return null;
}
